/** @format */

import React from "react";
import styled from "styled-components";

const ExpensesFilter = ({ selected, onFilterChange }) => {
	const dropDownChangeHandler = (event) => {
		onFilterChange(event.target.value);
	};

	return (
		<ExpenseFilterWrapper>
			<div className='expenses-filter__control'>
				<label>Filter by year</label>
				<select value={selected} onChange={dropDownChangeHandler}>
					<option value='2022'>2022</option>
					<option value='2021'>2021</option>
					<option value='2020'>2020</option>
					<option value='2019'>2019</option>
				</select>
			</div>
		</ExpenseFilterWrapper>
	);
};

export default ExpensesFilter;

const ExpenseFilterWrapper = styled.div`
	color: white;
	padding: 0 1rem;

	.expenses-filter__control {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-between;
		margin: 1rem 0;

		label {
			font-weight: bold;
			margin-bottom: 0.5rem;
		}

		select {
			font: inherit;
			padding: 0.5rem 3rem;
			font-weight: bold;
			border-radius: 6px;
		}
	}
`;
